import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../../store';
import {cssProperties} from '../../../css/cssProperties';

@customElement('visual-lightprofile-summary-lamp-data')
export class VisualLightprofileSummaryLampData extends connect(store)(LitElement) {

	static styles = [
		css`
			.lampData {
				padding: 50px 30px;
			}

			.lampDataContainer {
				display: grid;
				grid-auto-flow: dense;
				grid-template-columns: 3fr 9fr;
				gap: 0px;
				padding: 0 16px 0 0;
			}

			.description {
				color: var(--color-grey4);
				font: var(--font-summary-paragraph);
				line-height: 22px;
				max-width: 70%;
				text-align: left;
			}

			.description h5 {
				color: var(--color-white);
			}

			@media (max-width: 768px) {
				.lampData {
					padding: 50px var(--small-padding);
				}

				.lampDataContainer {
					display: block;
					padding: 0;
				}

				.dataList {
					margin-left: 0;
					max-width: 100%;
					column-count: 1;
				}

				.label {
					width: 52vw;
				}

				.value {
					width: 28vw;
				}

				trans-label {
					width: 60vw;
				}

				trans-label.white  {
					display: table-cell;
				}
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	render() {
		return html`
		<section class="lampData">
			<div class="lampDataContainer">
				<div class="description">
					<h5>${msg('Luminaire Data')}</h5>
				</div>
				<features-full-list class-name="summary"></features-full-list>
			</div>
		</section>
		`;
	}
}

